import React, { createContext, useContext, useState } from "react";

const BreadcrumbContext = createContext();



export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [isDrilldown, setIsDrilldown] = useState(false);
  const [isBreadcrumbNav, setIsBreadcrumbNav] = useState(false);

  const beginDrilldown = () => setIsDrilldown(true);
  const endDrilldown = () => setIsDrilldown(false);
  const beginBreadcrumbNav = () => setIsBreadcrumbNav(true);
  const endBreadcrumbNav = () => setIsBreadcrumbNav(false);
  
  const push = (crumb) => {
    setBreadcrumbs(prev => {
        // If the last breadcrumb is the same, do nothing
        const last = prev[prev.length - 1];
        if (last && last.label === crumb.label) {
        return prev;
        }
        return [...prev, crumb];
    });
  };                                                                  

  const pop = () => {
    setBreadcrumbs(prev => prev.slice(0, -1));
  };

  const reset = (crumbs = []) => {
    setBreadcrumbs(crumbs);
  };

  const goTo = (index) => {
    beginBreadcrumbNav();
    setBreadcrumbs(prev => prev.slice(0, index + 1));
  };

  return (
    <BreadcrumbContext.Provider
      value={{ breadcrumbs, push, pop, reset, goTo, beginDrilldown, endDrilldown, beginBreadcrumbNav, endBreadcrumbNav, isBreadcrumbNav, isDrilldown }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbContext);
